import React from 'react';

// Types
import { User } from 'Shared/constants/types';

// Hooks
import { useBaProfile } from 'Shared/utils/hooks/use-ba-profile';

// Components
import ReferencePatternIcon from 'Shared/components/ReferencePatternIcon/ReferencePatternIcon';

// Styles
import './BaProfileDisplayHeader.scss';

type Props = {
  user: User;
};

const BaProfileDisplayHeader = ({ user }: Props) => {
  const { referencePatternName } = useBaProfile({
    user,
    withFetch: false,
  });

  const baseClassName = 'BaProfileDisplayHeader';
  return (
    <div className={baseClassName}>
      <ReferencePatternIcon referencePattern={referencePatternName} className={`${baseClassName}__icon`} />
      <p className={`${baseClassName}__name`}>{user.fullName}</p>
    </div>
  );
};

export default BaProfileDisplayHeader;
